<template>
<v-card-text>
  <v-switch :label="`${$t('schema.builder.inputs.options.required')}`" :input-value="options.required" @change="update({required: $event})"></v-switch>
  <v-select :items="values" :value="options.answer" hint="Wybierz"
            item-text="value" item-value="key"
            label="Prawidłowa odpowieź" placeholder="Wybierz odpowiedz" @change="setAnswer($event)"></v-select>
  <v-text-field :value="options.answer_points" placeholder="1" @change="setAnswerPoints($event)" v-if="$store.state.schemaBuilder.type == schemaType.TEST"  :label="$t('test.answer_points')" ></v-text-field>

  <v-switch v-model="group" label="Grupy pól" @change="update({group: $event})"></v-switch>
  <div v-if="group">
    <div v-for="(value,index) in groups" :v-key="'group-'+ index">
      <h4>Grupa {{ index + 1 }}</h4>
      <v-text-field v-model="groups[index].name" label="Nazwa grupy" @change="update({groups})"></v-text-field>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <div :style="getColorIconStyle(value.color)"></div>
          <v-text-field v-model="groups[index].color" class="schema-name-input" label="Kolor" @change="update({groups})"
                        v-on="on"></v-text-field>
        </template>

        <v-container style="background-color: #ffffff">
          <color-picker v-bind="color"
                        @input="(hue) => onInput(hue, (hexColor) => value.color = hexColor)"></color-picker>
        </v-container>
      </v-menu>

      <v-select v-model="groups[index].keys" :items="values" item-text="value" item-value="key" label="Wartości"
                multiple @change="update({groups})"></v-select>
    </div>
    <v-btn small @click="addGroup()">
      Dodaj grupę
    </v-btn>
  </div>

</v-card-text>
</template>
<script>
import options from "@/mixins/options"
import schemaType from "@/enums/schemaType"
import color from "../../../../../mixins/color"
import ColorPicker from '@radial-color-picker/vue-color-picker'

export default {
  name: "radio-options",
  mixins: [options, color],
  components: {ColorPicker},
  data() {
    return {
      groups: [],
      group: false,
      lang: process.env.VUE_APP_LOCALE,
      answer : false,
      schemaType
    }
  },
  computed: {
    values() {
      try {
        let results = []
        if (this.context && this.context.getFields()) {
          results = this.context.getFields().find(el => el.id == this.id).values
        } else {
          results = this.$store.state.schemaBuilder.fields.find(el => el.id == this.id).values
        }

        if (results.length > 0) {
          results = results.map((el, index) => ({
            value: el.value,
            key: (el.key == undefined ? index + 1 : el.key)
          }))
        }

        return results
      } catch (e) {
        return []
      }

    }
  },
  created() {
    if (this.$store.state.schemaBuilder.type == schemaType.TEST) {
      this.setAnswerPoints(1)
    }
  },
  methods: {
    addGroup() {
      this.groups.push({"name": "", keys: [], color: "#000000"})
    },
    //val can be value name when it is new input/value option or value key when we edditing schema and value option existed
    setAnswer(val){
      let key = this.values.findIndex(el => el.value == val)
      key = key == -1 ? val : key + 1
      this.update({
        answer : key
      })
    },
    setAnswerPoints(val){
      this.update({
        answer_points : val
      })
    },
    getValue(orgValue) {
      return orgValue
    },

  },

}
</script>
<style>
</style>
